export default __webpack_public_path__ + "static/media/include_1@3x.db7ae3a8.jpg";